import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { Layout, Menu, Button, Select, List, message } from "antd";
import { useContext } from "react";
import { UserContext } from "../../UserContext";
import LoaderTeacher from "../../Loader/Loader_Teacher";
import QuizEditor from "../QuizEditor";
import "./Course.css";

const { Header, Sider, Content } = Layout;

const Publish = () => {
	const [messageApi, contextHolder] = message.useMessage();
	const { course } = useParams();
	const { instructorapiuri, token } = useContext(UserContext);
	const [preq, setPreq] = useState([]);
	const navigate = useNavigate();

	const getPrereq = async () => {
		try {
			const response = await fetch(`${instructorapiuri}/inst/${course}/preq`, {
				method: "GET",
				headers: {
					Authorization: "BEARER: " + token,
				},
			});
			const data = await response.json();
            console.log(data)
			if (data.data) {
				setPreq([data.data]);
			} else {
				setPreq([]);
			}
		} catch (error) {
			console.error("Error fetching prereq:", error);
			setPreq([]);
		}
	};

	useEffect(() => {
		getPrereq();
	}, [course]);

	const handlechange = (value) => {
		console.log("value", value);
		setPreq([value]);
	};

	const handleSave = async () => {
		console.log({ prereq: preq[0] });
		const response = await fetch(
			`${instructorapiuri}/inst/${course}/savepreq`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "BEARER " + token,
				},
				body: JSON.stringify({ prereq: preq[0] }),
			}
		);

		const data = await response.json();
		if (data.status === "success") {
			const pubres = await fetch(`${instructorapiuri}/inst/${course}/kt`, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "BEARER " + token,
				},
				body: JSON.stringify({ prereq: preq[0].join(",") }),
			});
			const pubdata = await pubres.json();
			messageApi.success("successfully created");
			if (pubdata) {
				try {
					navigate(`/teacher/courses/${course}/kt`, {
						replace: true,
						state: {
							quizData: pubdata?.data,
							prereq: preq[0].join(","),
						},
					});
				} catch (error) {
					console.error("Navigation error:", error);
				}
			}
		} else {
			messageApi.error(`Failed to save changes`);
		}
	};
    

	return (
		<Layout style={{ minHeight: "100vh" }}>
			<Sider
				breakpoint="md"
				collapsedWidth="0"
				className="course-side-menu"
				style={{
					position: "fixed",
				}}>
				<Menu mode="inline" theme="dark" className="menu">
					<Menu.Item key={"Prereq"}>
						<Button type="text">PRE REQ</Button>
					</Menu.Item>
					<Menu.Item key={"savecourse"}>
						<Button type="text" onClick={handleSave}>
							Save Course
						</Button>
					</Menu.Item>
				</Menu>
			</Sider>
			<Layout>
				<Header className="head">
					<div className="title">LEARN YOUR WAY</div>
					<div
						style={{ display: "flex", alignItems: "center" }}
						className="head-icons">
						<Link to={"/"}>
							<UserOutlined />
						</Link>
						<Link to={"/"}>
							<LogoutOutlined />
						</Link>
					</div>
				</Header>
				<Content className="content">
                Enter Prerequisites for Course
					<Select
						mode="tags"
						style={{
							width: "100%",
						}}
						onChange={handlechange}
						tokenSeparators={[","]}
						options={[preq]}
					/>
                    Prerequisites: {[preq]}<br />
					<Button onClick={handleSave}>Save</Button>
					{contextHolder}
				</Content>
			</Layout>
		</Layout>
	);
};

export default Publish;
